/* global analytics */
import React from "react";

import "./CustomizationCTA.css";

function CustomizationCTA(props) {
    return (
        <div className={"cust-cta " + (props.isMobile ? "sizeSmall" : "sizeLarge")}>
            <div className="cust-cta--bg"></div>
            <div className="cust-cta__icons">
                <i className="fal fa-surprise"></i>
                <i className="fal fa-heart"></i>
                <i className="fal fa-hand-holding-box"></i>
            </div>
            <p className="cust-cta__text">
                Ready to customize your own box?
            </p>
            <button className="sbh__gtb shared-button shared-button-cta" onClick={handleClick}>GET THE BOX</button>
        </div>
    )
}

function handleClick() {
    window.location.href = "/get-the-box/?step=getbox";
    analytics.track('Clicked Element', {
        element_name: 'Get the Box',
        option_title: 'Page header'
      });
}

export default CustomizationCTA;


// WEBPACK FOOTER //
// ./src/Components/Panels/CustomizationCTA/CustomizationCTA.js